import { render, staticRenderFns } from "./ChannelDown.vue?vue&type=template&id=bf46f762"
import script from "./ChannelDown.vue?vue&type=script&lang=js"
export * from "./ChannelDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports